import { CLIENT_TYPE, Condition } from '@upstart/harmony/lib/constants';

export enum Action {
  START = 'start',
  SAVE = 'save',
  REVERT = 'revert',
  CANCEL = 'cancel',
  CLICK = 'click',
  FINISH = 'finish',
  OVERRIDE = 'override',
}

export enum ModalType {
  ACCESSORIES = 'accessories',
  ADD_ONS = 'addOns',
  DEALER_FEES = 'dealerFees',
  INCENTIVES = 'incentives',
  PROTECTION_PLANS = 'protectionPlans',
  TAX_RATE = 'taxRate',
}

export enum VehicleSelectedAction {
  SEARCH_STOCK_START = 'search_stock_start',
  SEARCH_MMT_START = 'search_mmt_start',
  VEHICLE_SELECTED = 'vehicle_selected',
  ADDOTHER_CLICKED = 'addother_clicked',
  ADDOTHER_START = 'addother_start',
  ADDOTHER_VIN_START = 'addother_vin_start',
  ADDOTHER_VIN_CANCEL = 'addother_vin_cancel',
  ADDOTHER_VIN_FINISH = 'addother_vin_finish',
  ADDOTHER_MANUALLY_START = 'addother_manually_start',
  ADDOTHER_MANUALLY_CANCEL = 'addother_manually_cancel',
  ADDOTHER_MANUALLY_FINISH = 'addother_manually_finish',
  ADDOTHER_FINISH = 'addother_finish',
  FINISH = 'finish',
}

export const desking = 'desking';

export const pricing = 'pricing';

export const amplitudeEvents = {
  OFFER_REFRESH_MODAL_CONTINUE: 'offer_refresh_modal_continue_clicked',
  OFFER_REHASH_MODAL_CONTINUE: 'offer_rehash_modal_continue_clicked',
  OFFER_REHASH_NOT_NEEDED: 'offer_rehash_not_needed',
  OFFER_REHASH_REFRESH_KEEP_ORIGINAL: 'offer_keep_original_clicked',
  OFFER_REHASH_MODAL_OPEN: 'offer_rehash_modal_opened',
  OFFER_REFRESH_MODAL_OPEN: 'offer_refresh_modal_opened',
  DESKING_PENCIL_START: 'desking_pencil_start',
  DESKING_PENCIL_TAB_FINANCE_START: 'desking_pencil_tab_finance_start',
  DESKING_PENCIL_TAB_CASH_START: 'desking_pencil_tab_cash_start',
  DESKING_PENCIL_TAB_LEASE_START: 'desking_pencil_tab_lease_start',
  DESKING_PENCIL_TAB_SELECTEDPENCILS_START:
    'desking_pencil_tab_selectedpencils_start',
  DESKING_PENCIL_TAB_FINANCEOFFERS_START:
    'desking_pencil_tab_financeoffers_start',
  DESKING_PENCIL_CUSTOMER_INFO_CLICK: 'desking_pencil_customerinfo_click',
  DESKING_PENCIL_CUSTOMER_INFO_START: 'desking_pencil_customerinfo_start',
  DESKING_PENCIL_CUSTOMER_INFO_FINISH: 'desking_pencil_customerinfo_finish',
  DESKING_PENCIL_CUSTOMER_INFO_CANCEL: 'desking_pencil_customerinfo_cancel',
  DESKING_PENCIL_MILEAGE_CLICK: 'desking_pencil_mileage_click',
  DESKING_PENCIL_MILEAGE_START: 'desking_pencil_mileage_start',
  DESKING_PENCIL_MILEAGE_FINISH: 'desking_pencil_mileage_finish',
  DESKING_PENCIL_MILEAGE_CANCEL: 'desking_pencil_mileage_cancel',
  DESKING_PENCIL_TRADE_CLICK: 'desking_pencil_trade_click',
  DESKING_PENCIL_TRADE_START: 'desking_pencil_trade_start',
  DESKING_PENCIL_TRADE_FINISH: 'desking_pencil_trade_finish',
  DESKING_PENCIL_TRADE_CANCEL: 'desking_pencil_trade_cancel',
  DESKING_PENCIL_FORMS_CLICK: 'desking_pencil_forms_click',
  DESKING_PENCIL_FORMS_START: 'desking_pencil_forms_start',
  DESKING_PENCIL_FORMS_VIEW_CLICK: 'desking_pencil_forms_view_click',
  DESKING_PENCIL_FORMS_VIEW_START: 'desking_pencil_forms_view_start',
  DESKING_PENCIL_FORMS_VIEW_FINISH: 'desking_pencil_forms_view_finish',
  DESKING_PENCIL_FORMS_BACK_TO_DESKING_CLICK:
    'desking_pencil_forms_back_to_desking_click',
  DESKING_PENCIL_NOTES_CLICK: 'desking_pencil_notes_click',
  DESKING_PENCIL_NOTES_START: 'desking_pencil_notes_start',
  DESKING_PENCIL_NOTES_FINISH: 'desking_pencil_notes_finish',
  DESKING_PENCIL_NOTES_CANCEL: 'desking_pencil_notes_cancel',
  DESKING_PENCIL_SEND_CUSTOMER_CLICK: 'desking_pencil_sendcustomer_click',
  DESKING_PENCIL_SEND_SALESPERSON_START: 'desking_pencil_sendsalesperson_start',
  DESKING_PENCIL_SEND_SALESPERSON_FINISH:
    'desking_pencil_sendsalesperson_finish',
  DESKING_PENCIL_SEND_SALESPERSON_ERROR: 'desking_pencil_sendsalesperson_error',
  DESKING_PENCIL_VEHICLE_PRIMARY_CLICK: 'desking_pencil_vehicle_primary_click',
  DESKING_PENCIL_VEHICLE_REMOVE_CLICK: 'desking_pencil_vehicle_remove_click',
  DESKING_PUSHDMS_CLICK: 'desking_pushdms_click',
  DESKING_PUSHDMS_START: 'desking_pushdms_start',
  DESKING_PUSHDMS_FINISH: 'desking_pushdms_finish',
  DESKING_PUSHDMS_ERROR: 'desking_pushdms_error',
  DESKING_EDIT_RIC_START: 'desking_edit_ric_start',
  DESKING_EDIT_RIC_FINISH: 'desking_edit_ric_finish',
  OPEN_CREDIT_APP_FROM_DESKING: 'open_credit_app_from_desking',
} as const;

export const amplitudeEventsPricing = {
  [CLIENT_TYPE.IN_STORE]: {
    [Condition.NEW]: {
      [Action.START]: 'pricinginventory_instore_new_start',
      [Action.SAVE]: 'pricinginventory_instore_new_save',
      [Action.REVERT]: 'pricinginventory_instore_new_revert',
    },
    [Condition.USED]: {
      [Action.START]: 'pricinginventory_instore_used_start',
      [Action.SAVE]: 'pricinginventory_instore_used_save',
      [Action.REVERT]: 'pricinginventory_instore_used_revert',
    },
    [Condition.CPO]: {
      [Action.START]: 'pricinginventory_instore_cpo_start',
      [Action.SAVE]: 'pricinginventory_instore_cpo_save',
      [Action.REVERT]: 'pricinginventory_instore_cpo_revert',
    },
  },
  [CLIENT_TYPE.ONLINE]: {
    [Condition.NEW]: {
      [Action.START]: 'pricinginventory_online_new_start',
      [Action.SAVE]: 'pricinginventory_online_new_save',
      [Action.REVERT]: 'pricinginventory_online_new_revert',
    },
    [Condition.USED]: {
      [Action.START]: 'pricinginventory_online_used_start',
      [Action.SAVE]: 'pricinginventory_online_used_save',
      [Action.REVERT]: 'pricinginventory_online_used_revert',
    },
    [Condition.CPO]: {
      [Action.START]: 'pricinginventory_online_cpo_start',
      [Action.SAVE]: 'pricinginventory_online_cpo_save',
      [Action.REVERT]: 'pricinginventory_online_cpo_revert',
    },
  },
} as const;

export const amplitudeEventsPricingAddVehicle = {
  [Action.CLICK]: 'desking_pencil_addvehicle_click',
  [Action.START]: 'desking_pencil_addvehicle_start',
  [VehicleSelectedAction.SEARCH_STOCK_START]:
    'desking_pencil_addvehicle_search_stock_start',
  [VehicleSelectedAction.SEARCH_MMT_START]:
    'desking_pencil_addvehicle_search_mmt_start',
  [VehicleSelectedAction.VEHICLE_SELECTED]:
    'desking_pencil_addvehicle_vehicle_selected',
  [VehicleSelectedAction.ADDOTHER_CLICKED]:
    'desking_pencil_addvehicle_vehicle_clicked',
  [VehicleSelectedAction.ADDOTHER_START]:
    'desking_pencil_addvehicle_addother_start',
  [VehicleSelectedAction.ADDOTHER_VIN_START]:
    'desking_pencil_addvehicle_addother_vin_start',
  [VehicleSelectedAction.ADDOTHER_VIN_CANCEL]:
    'desking_pencil_addvehicle_addother_vin_cancel',
  [VehicleSelectedAction.ADDOTHER_VIN_FINISH]:
    'desking_pencil_addvehicle_addother_vin_finish',
  [VehicleSelectedAction.ADDOTHER_MANUALLY_START]:
    'desking_pencil_addvehicle_addother_manually_start',
  [VehicleSelectedAction.ADDOTHER_MANUALLY_CANCEL]:
    'desking_pencil_addvehicle_addother_manually_cancel',
  [VehicleSelectedAction.ADDOTHER_MANUALLY_FINISH]:
    'desking_pencil_addvehicle_addother_manually_finish',
  [VehicleSelectedAction.ADDOTHER_FINISH]:
    'desking_pencil_addvehicle_addother_finish',
  [VehicleSelectedAction.FINISH]: 'desking_pencil_addvehicle_finish',
};

export const amplitudeEventsVehicleselection = {
  [Action.START]: 'desking_vehicleselection_start',
  [VehicleSelectedAction.SEARCH_STOCK_START]:
    'desking_vehicleselection_search_stock_start',
  [VehicleSelectedAction.SEARCH_MMT_START]:
    'desking_vehicleselection_search_mmt_start',
  [VehicleSelectedAction.VEHICLE_SELECTED]:
    'desking_vehicleselection_vehicle_selected',
  [VehicleSelectedAction.ADDOTHER_CLICKED]:
    'desking_vehicleselection_addother_clicked',
  [VehicleSelectedAction.ADDOTHER_START]:
    'desking_vehicleselection_addother_start',
  [VehicleSelectedAction.ADDOTHER_VIN_START]:
    'desking_vehicleselection_addother_vin_start',
  [VehicleSelectedAction.ADDOTHER_VIN_CANCEL]:
    'desking_vehicleselection_addother_vin_cancel',
  [VehicleSelectedAction.ADDOTHER_VIN_FINISH]:
    'desking_vehicleselection_addother_vin_finish',
  [VehicleSelectedAction.ADDOTHER_MANUALLY_START]:
    'desking_vehicleselection_addother_manually_start',
  [VehicleSelectedAction.ADDOTHER_MANUALLY_CANCEL]:
    'desking_vehicleselection_addother_manually_cancel',
  [VehicleSelectedAction.ADDOTHER_MANUALLY_FINISH]:
    'desking_vehicleselection_addother_manually_finish',
  [VehicleSelectedAction.FINISH]: 'desking_vehicleselection_finish',
} as const;

export const amplitudeEventsDesking: any = {
  [ModalType.ACCESSORIES]: {
    [Action.CLICK]: 'desking_pencil_accessories_click',
    [Action.START]: 'desking_pencil_accessories_start',
    [Action.FINISH]: 'desking_pencil_accessories_finish',
    [Action.CANCEL]: 'desking_pencil_accessories_cancel',
  },
  [ModalType.ADD_ONS]: {
    [Action.CLICK]: 'desking_pencil_addons_click',
    [Action.START]: 'desking_pencil_addons_start',
    [Action.FINISH]: 'desking_pencil_addons_finish',
    [Action.CANCEL]: 'desking_pencil_addons_cancel',
  },
  [ModalType.DEALER_FEES]: {
    [Action.CLICK]: 'desking_pencil_dealerfees_click',
    [Action.START]: 'desking_pencil_dealerfees_start',
    [Action.FINISH]: 'desking_pencil_dealerfees_finish',
    [Action.CANCEL]: 'desking_pencil_dealerfees_cancel',
  },
  [ModalType.INCENTIVES]: {
    [Action.CLICK]: 'desking_pencil_incentives_click',
    [Action.START]: 'desking_pencil_incentives_start',
    [Action.FINISH]: 'desking_pencil_incentives_finish',
    [Action.CANCEL]: 'desking_pencil_incentives_cancel',
  },
  [ModalType.PROTECTION_PLANS]: {
    [Action.CLICK]: 'desking_pencil_protectionplans_click',
    [Action.START]: 'desking_pencil_protectionplans_start',
    [Action.FINISH]: 'desking_pencil_protectionplans_finish',
    [Action.CANCEL]: 'desking_pencil_protectionplans_cancel',
  },
  [ModalType.TAX_RATE]: {
    [Action.CLICK]: 'desking_pencil_tax_click',
    [Action.START]: 'desking_pencil_tax_start',
    [Action.FINISH]: 'desking_pencil_tax_finish',
    [Action.CANCEL]: 'desking_pencil_tax_cancel',
    [Action.OVERRIDE]: 'desking_pencil_tax_override_selected',
  },
};

export const amplitudeEventsShareDeal = {
  SHARE_DEAL_START: 'sharedeal_start',
  SHARE_DEAL_PREVIEW_STICKER_VIEWED: 'sharedeal_previewsticker_viewed',
  SHARE_DEAL_CANCEL: 'sharedeal_cancel',
  SHARE_DEAL_PREVIEW_STICKER_EDIT_TERMS_CLICKED:
    'sharedeal_previewsticker_edit_terms_clicked',
  SHARE_DEAL_SENT: 'sharedeal_sent',
  SHARE_DEAL_PREVIEW_STICKER_PRINT_CLICKED:
    'sharedeal_previewsticker_print_clicked',
};

export const amplitudeEventsInvoice = {
  DESKING_PENCIL_INVOICE_PRICE_START: 'desking_pencil_invoice_price_start',
  DESKING_PENCIL_INVOICE_PRICE_FINISH: 'desking_pencil_invoice_price_finish',
};

export const amplitudeEventsDeskingCTR = {
  DESKING_DEAL_PAGE_VIEW: 'desking_deal_page_view',
  DESKING_TAB_CLICKED: 'desking_tab_clicked',
  FINANCE_OFFER_TILE_CLICKED: 'finance_offer_tile_clicked',
  DUPLICATE_OFFER_BUTTON_CLICKED: 'duplicate_offer_button_clicked',
  UPSTART_OFFER_DETAILS_VIEW: 'upstart_offer_details_view',
  UPSTART_OFFER_EDIT_DETAILS_CLICKED: 'upstart_offer_edit_details_clicked',
  UPSTART_OFFER_SAVE_DETAILS_CLICKED: 'upstart_offer_save_details_clicked',
  DESKING_FINANCE_OFFER_SENT: 'desking_finance_offer_sent',
  DESKING_SENT_TO_SALESPERSON: 'desking_sent_to_salesperson',
  DESKING_PRESENTED_TO_CUSTOMER: 'desking_presented_to_customer',
  PULL_FROM_DMS: 'pull_from_dms',
  FINANCING_PULLDMS_START: 'financing_pulldms_start',
  FINANCING_PULLDMS_FINISH: 'financing_pulldms_finish',
  FINANCING_PULLDMS_ERROR: 'financing_pulldms_error',
  FINANCE_START_ECONTRACT_CLICKED: 'finance_start_econtract_clicked',
  FINANCE_START_ECONTRACT_FINISHED: 'finance_start_econtract_finished',
};
